var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseLarge = function SvgCloseLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close-a",
    d: "M18 16.9l1.22-1.525a1 1 0 1 1 1.56 1.25l-1.5 1.875 1.5 1.875a1 1 0 1 1-1.56 1.25L18 20.1l-1.22 1.524a1 1 0 1 1-1.56-1.25l1.5-1.875-1.5-1.875a1 1 0 0 1 1.56-1.25L18 16.9zM18 36C8.059 36 0 27.941 0 18S8.059 0 18 0s18 8.059 18 18-8.059 18-18 18zm0-2c8.837 0 16-7.163 16-16S26.837 2 18 2 2 9.163 2 18s7.163 16 16 16z"
  })));
};
export default SvgCloseLarge;